import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardOutline = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "ic_24/Card_outline",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Rectangle 240648428 (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.6 6.6H5.4C4.40589 6.6 3.6 7.40589 3.6 8.4V16.6C3.6 17.5941 4.40589 18.4 5.4 18.4H18.6C19.5941 18.4 20.4 17.5941 20.4 16.6V8.4C20.4 7.40589 19.5941 6.6 18.6 6.6ZM5.4 5C3.52223 5 2 6.52223 2 8.4V16.6C2 18.4778 3.52223 20 5.4 20H18.6C20.4778 20 22 18.4778 22 16.6V8.4C22 6.52223 20.4778 5 18.6 5H5.4Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle 240648056",
			x: 14,
			y: 14,
			width: 4,
			height: 2,
			rx: 1,
			fill: "white"
		})]
	})
});
const ForwardRef = forwardRef(SvgCardOutline);
export default ForwardRef;
